import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { rem } from "polished"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import PostsHighlights from "../components/posts-highlights"
import PostCard from "../components/post-card"
import PhotoHero from "../components/photo-hero"

const Grid = styled.ul`
  ${({ theme }) => theme.grid.container()}

  margin-top: ${rem(40)};
  margin-bottom: ${rem(40)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    margin-top: ${rem(20)};
    margin-bottom: ${rem(20)};
  }

  > ul {
    ${({ theme }) => theme.grid.grid()}
    ${({ theme }) => theme.grid.gridGutterX()}
    ${({ theme }) => theme.grid.gridGutterY(30)}

    > li {
      ${({ theme }) => theme.grid.cell(4)}

      @media ${({ theme }) => theme.mq.xlargeDown} {
        ${({ theme }) => theme.grid.cell(6)}
      }

      @media ${({ theme }) => theme.mq.smallDown} {
        ${({ theme }) => theme.grid.cell(12)}
      }
    }
  }
`

const Description = styled.div`
  ${({ theme }) => theme.grid.container(`xnarrow`)}

  font-size: ${rem(18)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.gray};
  margin-top: ${rem(40)};
`

const ArticlesPage = ({ data: { config, articles, img } }) => {
  const highlightItemsMax = 3
  let highlightItems = null
  let gridItems = null

  if (articles && articles.nodes.length >= highlightItemsMax) {
    highlightItems = articles.nodes.slice(0, highlightItemsMax)
    gridItems = articles.nodes.slice(highlightItemsMax)
  } else {
    highlightItems = articles.nodes
  }

  return (
    <Layout>
      <PhotoHero
        title={config.pages.articles.title}
        intro={config.pages.articles.intro}
        image={img}
      />

      {config.pages.articles.description && (
        <Description
          dangerouslySetInnerHTML={{
            __html: config.pages.articles.description,
          }}
        />
      )}

      {highlightItems && !!highlightItems.length && (
        <PostsHighlights data={highlightItems} />
      )}

      {gridItems && !!gridItems.length && (
        <Grid>
          <ul>
            {gridItems.map((item, i) => (
              <li key={i}>
                <PostCard data={item} />
              </li>
            ))}
          </ul>
        </Grid>
      )}
    </Layout>
  )
}

export default ArticlesPage

export const Head = ({ data: { config } }) => {
  return <Meta data={{ title: config.pages.articles.title }} />
}

export const pageQuery = graphql`
  query {
    config: configJson {
      pages {
        articles {
          title
          intro
          description
        }
      }
    }

    articles: allArticlesJson(sort: { publish_at: DESC }) {
      nodes {
        ...ArticlesCardFragment
      }
    }

    img: file(
      sourceInstanceName: { eq: "images" }
      relativePath: { eq: "content/discover.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 1920)
      }
    }
  }
`
